// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_text__gwEeA {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  box-sizing: border-box;
  color: #707070;
  margin: 2em 0;
  box-sizing: border-box;
}

.styles_flexStyle__ZJQ4M {
  width: 100%;
  max-height: calc(65vh - 70px);
}

.styles_file__s7rsC {
  width: 31%;
  margin: 0 1%;
  height: 150px;
  display: flex;
  margin-bottom: 10px;
}

.styles_fileContainer__XwOH3 {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
}

.styles_file__s7rsC img,
.styles_file__s7rsC video {
  width: auto;
  max-width: 100%;
  max-height: 100%;
}

.styles_downloadIcon__ncWsI {
  position: absolute;
  bottom: 10px;
  left: 10px;
  cursor: pointer;
  padding: 4px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  color: unset !important;
  filter: unset !important;
}

.styles_absoluteName__O5mbP {
  max-width: 86%;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  padding: 4px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  color: #fff;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;
}

.styles_search__r1eOp {
  width: 50%;
}

.styles_showDesktop__lAfia {
  display: flex;
}

.styles_showMobile__lgkKQ {
  display: none;
}

.styles_submitItem__bPUOw {
  margin: 0 5px !important;
  margin-top: auto !important;
  cursor: pointer;
  flex-direction: row-reverse;
  border: 1px solid #d8000d;
  border-radius: 6px !important;
  background-color: #ffffff !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 16px !important;
  line-height: 25px !important;
  color: #e30813 !important;
}

.styles_submitItem__bPUOw span {
  color: #e30813 !important;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
}

.styles_formTitle__jQbs2 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
  padding-bottom: 1em;
}

.styles_forgetText__R4Lq9 {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #d8000d;
  padding-top: 4px;
  margin-bottom: 1em;
}

.styles_inputError__\\+hrly {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #d8000d;
  margin-top: 8px;
}

.styles_serverError__1aq2e {
  background: #d8000d;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__1aq2e span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_cardStyle__QzaX2 {
  width: 31% !important;
  margin-left: 1% !important;
  margin-right: 0 !important;
}

.styles_flexStyle__ZJQ4M {
  flex-direction: row;
  height: auto;
  overflow-y: auto;
  overflow: auto;
  /* max-width: 650px; */
  scrollbar-width: 10px;
}

.styles_srollDiv__6jKAg {
  width: 100%;
}

.styles_menu__kN-Fp {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  height: auto;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-width: 5px;
  margin-bottom: 10px;
}

.styles_menu__kN-Fp::-webkit-scrollbar {
  background: transparent;
  width: 8px;
}

.styles_menu__kN-Fp::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 100px;
  height: 8px;
}

.styles_menu__kN-Fp > p {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  color: #575757;
  margin: 20px 0;
  padding: 5px 20px;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}

.styles_sectionContainer__sYard {
  box-sizing: border-box;
  width: 100%;
  box-sizing: border-box;
}

.styles_menu__kN-Fp .styles_unActiveMenu__HtWYI {
  color: #575757;
  border-left: none;
}

.styles_flexStyle__ZJQ4M::-webkit-scrollbar {
  background: transparent;
  width: 10px;
}

.styles_flexStyle__ZJQ4M::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 100px;
  height: 10px;
}

.styles_flexStyle__ZJQ4M.styles_dark__IaAFX::-webkit-scrollbar-thumb {
  background-color: #555;
  border-radius: 100px;
  height: 10px;
}

.styles_inputStyle__8Qjby {
  width: 100% !important;
  height: 44px;
}

.styles_wrapper__eyrMr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  width: 100%;
  height: 44px;
}

.styles_submitItemButtom__G6N8D {
  margin: 0 5px;
  cursor: pointer;
  width: auto;
  border: 1px solid #d8000d;
  background-color: #ffffff;
  color: #e30813;
  min-width: 118px;
  padding: 6px 24px;
  width: auto;
  height: 36px;
  border-radius: 4px;
}

.styles_submitItemButtom__G6N8D.styles_uploadButtom__U72rF {
  background-color: #d8000d;
  color: #ffffff !important;
}

.styles_submitItemButtom__G6N8D span {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  color: #e30813;
}

.styles_submitItemButtom__G6N8D.styles_uploadButtom__U72rF span {
  color: #ffffff;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
}

.styles_parent_input_email__Io-qA {
  width: 328px !important;
}

.styles_class_title_email__fQEod {
  margin-top: 16px !important;
  margin-bottom: 13px;
  color: #bababa;
  font-size: 14px;
}

.styles_text_area__4mJkQ {
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  padding: 20px 10px 0 0;
  font-size: 14px;
  color: #555;
}

.styles_titleStyle__KjFxg {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #bababa;
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 80px;
}

.styles_uploadButton__ElUIH {
  font-style: normal;
  font-weight: 700;
  font-size: 12.7619px;
  line-height: 20px;
  /* identical to box height */
  display: flex;
  align-items: center;
  text-align: center;
  color: #d8000d;
  padding: 5px 25px;
  border: 1px solid #d8000d;
  cursor: pointer;
}

.styles_uploadAffix__2plFS {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  text-align: center;
  /* Gray 3 */
  color: #828282;
  border-radius: 15px;
  border: 1px solid #828282;
  margin-right: 20px;
  padding: 5px;
}

.styles_searchPageSingleItem__5Au6w img,
.styles_searchPageSingleItem2__F67og img {
  border-radius: 8px;
  border-radius: 8px !important;
}

.styles_searchPageSingleItem__5Au6w {
  width: 340px;
  height: auto;
  aspect-ratio: 1.7;
}

.styles_searchPageSingleItem2__F67og {
  width: 100%;
  height: auto;
  aspect-ratio: 1.7;
}

.styles_searchPageSingleItem__5Au6w:hover,
.styles_searchPageSingleItem2__F67og:hover {
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.16));
}

.styles_searchPageSingleItem__5Au6w span > span > img {
  width: 100%;
  height: 100%;
}

.styles_absolute__Q0M5\\+ {
  display: flex;
  position: absolute;
  top: 100%;
  height: 200px;
  width: 50%;
  z-index: 1500;
  background-color: #ffffff;
  padding: 10px;
  z-index: 1500;
  padding-top: 40px;
  flex-direction: column;
  overflow-y: auto;
  overflow: auto;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.09);
  padding-top: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.styles_absolute__Q0M5\\+::-webkit-scrollbar {
  background: transparent;
  width: 10px;
}

.styles_absolute__Q0M5\\+::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 100px;
  height: 10px;
}

.styles_noInfoFound__GpfIe {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0 10px;
}

@media only screen and (max-width: 1920px) {
  .styles_searchPageSingleItem__5Au6w {
    width: 246px;
    height: auto;
    aspect-ratio: 1.7;
  }
  .styles_searchPageSingleItem2__F67og {
    width: 100%;
    height: auto;
    aspect-ratio: 1.7;
  }
}
@media only screen and (max-width: 1440px) {
  .styles_searchPageSingleItem__5Au6w img,
  .styles_searchPageSingleItem2__F67og img {
    border-radius: 8px;
    border-radius: 8px !important;
  }
  .styles_searchPageSingleItem__5Au6w {
    height: auto;
    aspect-ratio: 1.7;
  }
  .styles_searchPageSingleItem2__F67og {
    width: 100%;
    height: auto;
    aspect-ratio: 1.7;
  }
  .styles_searchPageSingleItem__5Au6w:hover,
  .styles_searchPageSingleItem2__F67og:hover {
    filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.16));
  }
  .styles_searchPageSingleItem__5Au6w span > span > img {
    width: 100%;
    height: 100%;
  }
}
@media only screen and (max-width: 1000px) {
  .styles_sideWidth__i\\+xMf {
    border: none !important;
  }
}
@media only screen and (max-width: 1200px) {
  .styles_gridStyle__le3kF {
    width: 50%;
  }
  .styles_searchPageSingleItem__5Au6w {
    width: 180px;
    height: auto;
    aspect-ratio: 1.7;
  }
  .styles_searchPageSingleItem2__F67og {
    width: 100%;
    height: auto;
    aspect-ratio: 1.7;
  }
}
@media only screen and (max-width: 900px) {
  .styles_searchPageSingleItem__5Au6w {
    width: 200px;
    height: auto;
    aspect-ratio: 1.7;
  }
  .styles_searchPageSingleItem2__F67og {
    width: 100%;
    height: auto;
    aspect-ratio: 1.7;
  }
  .styles_title__v9nCh {
    -webkit-line-clamp: 2;
    -moz-text-size-adjust: auto;
    height: 44px;
  }
}
@media only screen and (max-width: 800px) {
  .styles_showDesktop__lAfia {
    display: none;
  }
  .styles_showMobile__lgkKQ {
    display: flex;
  }
  .styles_menuMobile__9ImP5 {
    position: relative;
    flex-direction: row;
    height: auto;
    width: 90%;
    padding: 10px;
    margin: 0 auto;
  }
  .styles_menuMobile__9ImP5 .styles_activeMenu__v-L\\+v {
    color: #D8000D;
    border-bottom: 2px solid #D8000D;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }
  .styles_menuMobile__9ImP5 .styles_unActiveMenu__HtWYI {
    color: #575757;
    border-bottom: none;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }
  .styles_buttonContainer__a3hET {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0 auto !important;
    margin-bottom: 20px !important;
    margin-top: auto !important;
    padding-top: 20px !important;
  }
  .styles_flexStyle__ZJQ4M {
    flex-direction: column;
    margin: 0;
    padding-left: 0 !important;
  }
  .styles_searchPageSingleItem__5Au6w {
    width: 49%;
    margin-left: 1%;
  }
  .styles_container__Jvsco {
    width: 100%;
    margin: 0;
  }
  .styles_search__r1eOp {
    width: 100%;
  }
  .styles_fonts__XfNnh {
    font-size: 14px;
    height: auto !important;
  }
  .styles_fonts__XfNnh form p,
  .styles_menuMobile__9ImP5 p {
    font-size: 14px;
  }
  .styles_absolute__Q0M5\\+ {
    width: 100%;
  }
  .styles_cardStyle__QzaX2 {
    width: 48% !important;
    margin-left: 1% !important;
    margin-right: 1% !important;
  }
  .styles_paddingSet__ZlmEC {
    width: 100%;
    flex-direction: row;
  }
}
.styles_lds_ring__fdp7a {
  height: 40px;
}

.styles_lds_ring__fdp7a div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  animation: styles_lds_ring__fdp7a 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #ffffff transparent transparent transparent;
}

.styles_lds_ring__fdp7a div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ring__fdp7a div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ring__fdp7a div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ring__fdp7a {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 500px) {
  .styles_cardStyle__QzaX2,
  .styles_file__s7rsC {
    width: 48% !important;
  }
}
@media only screen and (max-width: 400px) {
  .styles_cardStyle__QzaX2,
  .styles_file__s7rsC {
    width: 98% !important;
  }
  .styles_menu__kN-Fp > p {
    font-size: 16px;
    padding: 5px 5px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FileSection/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EAEA,sBAAA;AAAF;;AAGA;EACE,WAAA;EAGA,6BAAA;AAFF;;AASA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AANF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;AAPF;;AAWA;;EAEE,WAAA;EACA,eAAA;EACA,gBAAA;AARF;;AAYA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;EAEA,wBAAA;AATF;;AAYA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;AATF;;AAYA;EACE,UAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,wBAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;AATF;;AAYA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AATF;;AAYA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AATF;;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AATF;;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AATF;;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATF;;AAYA;EACE,qBAAA;EACA,0BAAA;EACA,0BAAA;AATF;;AAYA;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EAEA,sBAAA;EAEA,qBAAA;AAXF;;AAcA;EACE,WAAA;AAXF;;AAcA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAIA,YAAA;EAGA,gBAAA;EAEA,qBAAA;EACA,oBAAA;EAEA,mBAAA;AAnBF;;AAsBA;EAEE,uBAAA;EACA,UAAA;AApBF;;AAuBA;EACE,yBAAA;EACA,oBAAA;EACA,WAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;AApBF;;AAuBA;EACE,sBAAA;EACA,WAAA;EACA,sBAAA;AApBF;;AA4BA;EACE,cAAA;EACA,iBAAA;AAzBF;;AA4BA;EAEE,uBAAA;EACA,WAAA;AA1BF;;AA6BA;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;AA1BF;;AA6BA;EACE,sBAAA;EACA,oBAAA;EACA,YAAA;AA1BF;;AA+BA;EACE,sBAAA;EACA,YAAA;AA5BF;;AA+BA;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AA7BF;;AA2CA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EAEA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAzCF;;AA4CA;EAEE,yBAAA;EACA,yBAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE,uBAAA;AA1CF;;AA6CA;EACE,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA1CF;;AA2DA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AAxDF;;AA2DA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAxDF;;AA2DA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,4BAAA;EAEA,aAAA;EACA,mBAAA;EACA,kBAAA;EAEA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,kBAAA;EAEA,WAAA;EAEA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AA7DF;;AAgEA;;EAEE,kBAAA;EACA,6BAAA;AA7DF;;AA8EA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AA3EF;;AAmFA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAhFF;;AAoFA;;EAEE,qDAAA;AAjFF;;AAoFA;EACE,WAAA;EACA,YAAA;AAjFF;;AAoFA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,2CAAA;EACA,iBAAA;EACA,8BAAA;EACA,+BAAA;AAjFF;;AAsFA;EAEE,uBAAA;EACA,WAAA;AApFF;;AAuFA;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;AApFF;;AAuFA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AApFF;;AAuFA;EACE;IACE,YAAA;IACA,YAAA;IACA,iBAAA;EApFF;EAwFA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAtFF;AACF;AA0FA;EAEE;;IAEE,kBAAA;IACA,6BAAA;EAzFF;EA4FA;IAKE,YAAA;IACA,iBAAA;EA9FF;EAiGA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EA/FF;EAmGA;;IAEE,qDAAA;EAjGF;EAoGA;IACE,WAAA;IACA,YAAA;EAlGF;AACF;AAqGA;EACE;IAEE,uBAAA;EApGF;AACF;AAuGA;EACE;IACE,UAAA;EArGF;EAwGA;IACE,YAAA;IACA,YAAA;IACA,iBAAA;EAtGF;EA0GA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAxGF;AACF;AA8GA;EACE;IACE,YAAA;IACA,YAAA;IACA,iBAAA;EA5GF;EAgHA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EA9GF;EAkHA;IACE,qBAAA;IACA,2BAAA;IACA,YAAA;EAhHF;AACF;AA8JA;EAKE;IACE,aAAA;EAhKF;EAmKA;IACE,aAAA;EAjKF;EAoKA;IACE,kBAAA;IACA,mBAAA;IACA,YAAA;IACA,UAAA;IACA,aAAA;IACA,cAAA;EAlKF;EAqKA;IACE,cAAA;IACA,gCAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;EAnKF;EAsKA;IACE,cAAA;IACA,mBAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;EApKF;EAwKA;IACE,sBAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,8BAAA;IACA,2BAAA;IACA,4BAAA;EAtKF;EAyKA;IACE,sBAAA;IACA,SAAA;IACA,0BAAA;EAvKF;EA0KA;IACE,UAAA;IACA,eAAA;EAxKF;EA2KA;IAEE,WAAA;IACA,SAAA;EA1KF;EA6KA;IACE,WAAA;EA3KF;EA+KA;IACE,eAAA;IACA,uBAAA;EA7KF;EAiLA;;IAEE,eAAA;EA/KF;EAkLA;IACE,WAAA;EAhLF;EAmLA;IACE,qBAAA;IACA,0BAAA;IACA,2BAAA;EAjLF;EAoLA;IACE,WAAA;IACA,mBAAA;EAlLF;AACF;AAuLA;EAIE,YAAA;AAxLF;;AA+LA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,yBAAA;EACA,kBAAA;EACA,4EAAA;EACA,yDAAA;AA7LF;;AAgMA;EACE,uBAAA;AA7LF;;AAgMA;EACE,sBAAA;AA7LF;;AAgMA;EACE,uBAAA;AA7LF;;AAgMA;EACE;IACE,uBAAA;EA7LF;EAgMA;IACE,yBAAA;EA9LF;AACF;AAkMA;EAEE;;IAEE,qBAAA;EAjMF;AACF;AAoMA;EAEE;;IAEE,qBAAA;EAnMF;EAsMA;IAEE,eAAA;IACA,gBAAA;EArMF;AACF","sourcesContent":[".text {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  box-sizing: border-box;\n  color: #707070;\n  margin: 2em 0;\n  // padding: 0 8px;\n  box-sizing: border-box;\n}\n\n.flexStyle {\n  width: 100%;\n  // max-height: 48vh;\n  // max-height:calc( 100% - 70px);\n  max-height: calc(65vh - 70px);\n}\n\n.sideWidth {\n  // width: 100%;\n}\n\n.file {\n  width: 31%;\n  margin: 0 1%;\n  height: 150px;\n  display: flex;\n  margin-bottom: 10px;\n\n}\n\n.fileContainer {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.3);\n  // padding-bottom:10px;\n}\n\n.file img,\n.file video {\n  width: auto;\n  max-width: 100%;\n  max-height: 100%;\n\n}\n\n.downloadIcon {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  cursor: pointer;\n  padding: 4px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 4px;\n  color: unset !important;\n  -webkit-filter: unset !important;\n  filter: unset !important;\n}\n\n.absoluteName {\n  max-width: 86%;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  padding: 4px;\n  font-size: 12px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 4px;\n  color: #fff;\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n}\n\n.search {\n  width: 50%;\n}\n\n.showDesktop {\n  display: flex;\n}\n\n.showMobile {\n  display: none;\n}\n\n.submitItem {\n  margin: 0 5px !important;\n  margin-top: auto !important;\n  cursor: pointer;\n  flex-direction: row-reverse;\n  border: 1px solid #d8000d;\n  border-radius: 6px !important;\n  background-color: #ffffff !important;\n  font-style: normal !important;\n  font-weight: bold !important;\n  font-size: 16px !important;\n  line-height: 25px !important;\n  color: #e30813 !important;\n}\n\n.submitItem span {\n  color: #e30813 !important;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n}\n\n.formTitle {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  padding-bottom: 1em;\n}\n\n.forgetText {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #d8000d;\n  padding-top: 4px;\n  margin-bottom: 1em;\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #d8000d;\n  margin-top: 8px;\n}\n\n.serverError {\n  background: #d8000d;\n  border-radius: 4px;\n  color: #ffffff;\n  width: 100%;\n  height: auto;\n  padding: 0.5em;\n  margin-bottom: 1em;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.serverError span {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0 2px;\n}\n\n.cardStyle {\n  width: 31% !important;\n  margin-left: 1% !important;\n  margin-right: 0 !important;\n}\n\n.flexStyle {\n  flex-direction: row;\n  height: auto;\n  overflow-y: auto;\n  overflow: auto;\n  // background: #ffffff;\n  /* max-width: 650px; */\n  // scrollbar-color: #e3e3e3 transparent;\n  scrollbar-width: 10px;\n}\n\n.srollDiv {\n  width: 100%;\n}\n\n.menu {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  // width: 25%;\n  width: 100%;\n  height: auto;\n  // position: fixed;\n  // border-left: 1px solid #eeeeee;\n  // min-height: 80%;\n  height: auto;\n  // position: absolute;\n  // right: 0;\n  overflow-x: auto;\n  // scrollbar-color: #e3e3e3 transparent;\n  scrollbar-width: thin;\n  scrollbar-width: 5px;\n\n  margin-bottom: 10px;\n}\n\n.menu::-webkit-scrollbar {\n  // display: none !important;\n  background: transparent;\n  width: 8px;\n}\n\n.menu::-webkit-scrollbar-thumb {\n  background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 8px;\n}\n\n.menu>p {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 20px;\n  color: #575757;\n  margin: 20px 0;\n  padding: 5px 20px;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.sectionContainer {\n  box-sizing: border-box;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.menu .activeMenu {\n  // color: #d8000d;\n  // border-left: 2px solid #d8000d;\n}\n\n.menu .unActiveMenu {\n  color: #575757;\n  border-left: none;\n}\n\n.flexStyle::-webkit-scrollbar {\n  // display: none !important;\n  background: transparent;\n  width: 10px;\n}\n\n.flexStyle::-webkit-scrollbar-thumb {\n  background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 10px;\n}\n\n.flexStyle.dark::-webkit-scrollbar-thumb {\n  background-color: #555;\n  border-radius: 100px;\n  height: 10px;\n}\n\n.flexStyle>div:nth-child(2) {}\n\n.inputStyle {\n  width: 100% !important;\n  height: 44px;\n}\n\n.wrapper {\n  // width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  width: 100%;\n  height: 44px;\n}\n\n// @media only screen and (max-width: 1024px) {\n//   .flexStyle {\n//     flex-direction: column;\n//   }\n\n//   .flexStyle>div:nth-child(2) {\n//     margin: 0 auto;\n//     margin-top: 20px;\n//   }\n// }\n\n.submitItemButtom {\n  margin: 0 5px;\n  cursor: pointer;\n  width: auto;\n  border: 1px solid #d8000d;\n  background-color: #ffffff;\n  color: #e30813;\n  min-width: 118px;\n  // min-width: 154px;\n  padding: 6px 24px;\n  width: auto;\n  height: 36px;\n  border-radius: 4px;\n}\n\n.submitItemButtom.uploadButtom {\n  // border: 1px solid #ffffff;\n  background-color: #d8000d;\n  color: #ffffff !important;\n}\n\n.submitItemButtom span {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 25px;\n  text-align: center;\n  color: #e30813;\n}\n\n.submitItemButtom.uploadButtom span {\n  color: #ffffff;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n  text-align: center;\n}\n\n.parent_input_email {\n  width: 328px !important;\n}\n\n.class_title_email {\n  margin-top: 16px !important;\n  margin-bottom: 13px;\n  color: #bababa;\n  font-size: 14px;\n}\n\n// .parent_input_text_area {\n//   width: 100% !important;\n//   height: 148px !important;\n//   padding: 5px;\n//   background-color: #fafafa;\n//   border-radius: 8px;\n//   border: 1px solid #eeeeee;\n// }\n\n// .parent_input_text_area:active {\n//   background-color: #fafafa;\n//   outline: 1px solid #eeeeee;\n// }\n\n.text_area {\n  width: 100%;\n  height: 100%;\n  background-color: #fafafa;\n  padding: 20px 10px 0 0;\n  font-size: 14px;\n  color: #555;\n}\n\n.titleStyle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  color: #bababa;\n  margin-left: 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  min-width: 80px;\n}\n\n.uploadButton {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12.7619px;\n  line-height: 20px;\n  /* identical to box height */\n\n  display: flex;\n  align-items: center;\n  text-align: center;\n\n  color: #d8000d;\n  padding: 5px 25px;\n  border: 1px solid #d8000d;\n  cursor: pointer;\n}\n\n.uploadAffix {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  /* or 171% */\n\n  display: flex;\n  align-items: center;\n  text-align: center;\n\n  /* Gray 3 */\n\n  color: #828282;\n  border-radius: 15px;\n  border: 1px solid #828282;\n  margin-right: 20px;\n  padding: 5px;\n}\n\n.searchPageSingleItem img,\n.searchPageSingleItem2 img {\n  border-radius: 8px;\n  border-radius: 8px !important;\n  // box-sizing: border-box;\n  // width: 15.6666%;\n  // margin: 10px 0.5%;\n  // padding: 0.5%;\n  // min-height: 222px;\n}\n\n.searchPageSingleItem,\n.searchPageSingleItem2 {\n  // box-sizing: border-box;\n  // width: 15.6666%;\n  // margin: 10px 0.5%;\n  // padding: 0.5%;\n  // min-height: 222px;\n}\n\n.searchPageSingleItem {\n  width: 340px;\n  height: auto;\n  aspect-ratio: 1.7;\n  // height: 222px // width: 200px;\n  // min-height: 222px;\n  // margin: 10px 0.5%;\n  // padding: 0.5%;\n  // min-height: 222px;\n}\n\n.searchPageSingleItem2 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 1.7;\n  // height: 222px;\n}\n\n.searchPageSingleItem:hover,\n.searchPageSingleItem2:hover {\n  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.16));\n}\n\n.searchPageSingleItem span>span>img {\n  width: 100%;\n  height: 100%;\n}\n\n.absolute {\n  display: flex;\n  position: absolute;\n  top: 100%;\n  height: 200px;\n  width: 50%;\n  z-index: 1500;\n  background-color: #ffffff;\n  padding: 10px;\n  z-index: 1500;\n  padding-top: 40px;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow: auto;\n  box-shadow: 0px 4px 9px rgb(0 0 0 / 9%);\n  padding-top: 10px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  // border: 1px solid #dddddd;\n  // border-top: unset;\n}\n\n.absolute::-webkit-scrollbar {\n\n  background: transparent;\n  width: 10px;\n}\n\n.absolute::-webkit-scrollbar-thumb {\n  background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 10px;\n}\n\n.noInfoFound {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  padding: 0 10px;\n}\n\n@media only screen and (max-width: 1920px) {\n  .searchPageSingleItem {\n    width: 246px;\n    height: auto;\n    aspect-ratio: 1.7;\n    // height: 147px\n  }\n\n  .searchPageSingleItem2 {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1.7;\n    // height: 147px;\n  }\n}\n\n@media only screen and (max-width: 1440px) {\n\n  .searchPageSingleItem img,\n  .searchPageSingleItem2 img {\n    border-radius: 8px;\n    border-radius: 8px !important;\n  }\n\n  .searchPageSingleItem {\n    // width: 202px;\n    // height: 126px;\n    // width: 23%;\n    // margin: 0 1%;\n    height: auto;\n    aspect-ratio: 1.7;\n  }\n\n  .searchPageSingleItem2 {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1.7;\n    // height: 126px;\n  }\n\n  .searchPageSingleItem:hover,\n  .searchPageSingleItem2:hover {\n    filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.16));\n  }\n\n  .searchPageSingleItem span>span>img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@media only screen and (max-width: 1000px) {\n  .sideWidth {\n    // width: 100%;\n    border: none !important;\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  .gridStyle {\n    width: 50%;\n  }\n\n  .searchPageSingleItem {\n    width: 180px;\n    height: auto;\n    aspect-ratio: 1.7;\n    // height: 112px\n  }\n\n  .searchPageSingleItem2 {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1.7;\n    // height: 112px;\n  }\n\n\n}\n\n@media only screen and (max-width: 900px) {\n  .searchPageSingleItem {\n    width: 200px;\n    height: auto;\n    aspect-ratio: 1.7;\n    // height: 150px\n  }\n\n  .searchPageSingleItem2 {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1.7;\n    // height: 150px;\n  }\n\n  .title {\n    -webkit-line-clamp: 2;\n    -moz-text-size-adjust: auto;\n    height: 44px;\n  }\n}\n\n// @media only screen and (max-width: 798px) {\n//   .container {\n//     flex-direction: column;\n//     width: 90%;\n//     margin: 0 5%;\n\n//     .title {\n//       padding-top: 0.5rem;\n//       padding-bottom: 0.5rem;\n//     }\n\n//     .extraPadding {\n//       padding-top: 0.5rem;\n//       padding-bottom: 0.5rem;\n//     }\n//   }\n\n//   .container a {\n//     width: 100%;\n//   }\n\n//   .searchPageSingleItem {\n//     width: 100%;\n//     height: auto;\n//     aspect-ratio: 1.7;\n//     // height: 200px;\n//     // width: 150px;\n//     // height: 150px\n//   }\n\n//   .searchPageSingleItem2 {\n//     width: 100%;\n//     height: auto;\n//     aspect-ratio: 1.7;\n//     // height: 200px;\n//   }\n\n//   // .gridStyle {\n//   //   width: 90%;\n//   //   margin: 0 5%;\n//   // }\n// }\n\n@media only screen and (max-width: 800px) {\n  .menu {\n    // width:41%;\n  }\n\n  .showDesktop {\n    display: none;\n  }\n\n  .showMobile {\n    display: flex;\n  }\n\n  .menuMobile {\n    position: relative;\n    flex-direction: row;\n    height: auto;\n    width: 90%;\n    padding: 10px;\n    margin: 0 auto;\n  }\n\n  .menuMobile .activeMenu {\n    color: #D8000D;\n    border-bottom: 2px solid #D8000D;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n  }\n\n  .menuMobile .unActiveMenu {\n    color: #575757;\n    border-bottom: none;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n\n  }\n\n  .buttonContainer {\n    box-sizing: border-box;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    margin: 0 auto !important;\n    margin-bottom: 20px !important;\n    margin-top: auto !important;\n    padding-top: 20px !important;\n  }\n\n  .flexStyle {\n    flex-direction: column;\n    margin: 0;\n    padding-left: 0 !important;\n  }\n\n  .searchPageSingleItem {\n    width: 49%;\n    margin-left: 1%;\n  }\n\n  .container {\n    // height: 70vh !important;\n    width: 100%;\n    margin: 0;\n  }\n\n  .search {\n    width: 100%;\n  }\n\n\n  .fonts {\n    font-size: 14px;\n    height: auto !important;\n  }\n\n\n  .fonts form p,\n  .menuMobile p {\n    font-size: 14px;\n  }\n\n  .absolute {\n    width: 100%;\n  }\n\n  .cardStyle {\n    width: 48% !important;\n    margin-left: 1% !important;\n    margin-right: 1% !important;\n  }\n\n  .paddingSet {\n    width: 100%;\n    flex-direction: row;\n  }\n}\n\n//------------------------loader style\n\n.lds_ring {\n  // display: inline-block;\n  // position: absolute;\n  // width: 100%;\n  height: 40px;\n  // top: 20px;\n  // left: 20px;\n  // margin-bottom: 10px;\n  // margin-right: 20px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  // margin: 8px;\n  border: 1px solid #ffffff;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #ffffff transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n@media only screen and (max-width: 500px) {\n\n  .cardStyle,\n  .file {\n    width: 48% !important;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n\n  .cardStyle,\n  .file {\n    width: 98% !important;\n  }\n\n  .menu>p {\n\n    font-size: 16px;\n    padding: 5px 5px;\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `styles_text__gwEeA`,
	"flexStyle": `styles_flexStyle__ZJQ4M`,
	"file": `styles_file__s7rsC`,
	"fileContainer": `styles_fileContainer__XwOH3`,
	"downloadIcon": `styles_downloadIcon__ncWsI`,
	"absoluteName": `styles_absoluteName__O5mbP`,
	"search": `styles_search__r1eOp`,
	"showDesktop": `styles_showDesktop__lAfia`,
	"showMobile": `styles_showMobile__lgkKQ`,
	"submitItem": `styles_submitItem__bPUOw`,
	"formTitle": `styles_formTitle__jQbs2`,
	"forgetText": `styles_forgetText__R4Lq9`,
	"inputError": `styles_inputError__+hrly`,
	"serverError": `styles_serverError__1aq2e`,
	"cardStyle": `styles_cardStyle__QzaX2`,
	"srollDiv": `styles_srollDiv__6jKAg`,
	"menu": `styles_menu__kN-Fp`,
	"sectionContainer": `styles_sectionContainer__sYard`,
	"unActiveMenu": `styles_unActiveMenu__HtWYI`,
	"dark": `styles_dark__IaAFX`,
	"inputStyle": `styles_inputStyle__8Qjby`,
	"wrapper": `styles_wrapper__eyrMr`,
	"submitItemButtom": `styles_submitItemButtom__G6N8D`,
	"uploadButtom": `styles_uploadButtom__U72rF`,
	"parent_input_email": `styles_parent_input_email__Io-qA`,
	"class_title_email": `styles_class_title_email__fQEod`,
	"text_area": `styles_text_area__4mJkQ`,
	"titleStyle": `styles_titleStyle__KjFxg`,
	"uploadButton": `styles_uploadButton__ElUIH`,
	"uploadAffix": `styles_uploadAffix__2plFS`,
	"searchPageSingleItem": `styles_searchPageSingleItem__5Au6w`,
	"searchPageSingleItem2": `styles_searchPageSingleItem2__F67og`,
	"absolute": `styles_absolute__Q0M5+`,
	"noInfoFound": `styles_noInfoFound__GpfIe`,
	"sideWidth": `styles_sideWidth__i+xMf`,
	"gridStyle": `styles_gridStyle__le3kF`,
	"title": `styles_title__v9nCh`,
	"menuMobile": `styles_menuMobile__9ImP5`,
	"activeMenu": `styles_activeMenu__v-L+v`,
	"buttonContainer": `styles_buttonContainer__a3hET`,
	"container": `styles_container__Jvsco`,
	"fonts": `styles_fonts__XfNnh`,
	"paddingSet": `styles_paddingSet__ZlmEC`,
	"lds_ring": `styles_lds_ring__fdp7a`
};
export default ___CSS_LOADER_EXPORT___;
